var map = {
	"./en-CA.yaml": [
		73,
		32
	],
	"./en-US.yaml": [
		74,
		33
	],
	"./es-US.yaml": [
		75,
		34
	],
	"./fr-CA.yaml": [
		76,
		35
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 67;
module.exports = webpackAsyncContext;